import { render, staticRenderFns } from "./get-skill-output.vue?vue&type=template&id=bd4147ce&scoped=true"
import script from "./get-skill-output.vue?vue&type=script&lang=js"
export * from "./get-skill-output.vue?vue&type=script&lang=js"
import style0 from "./get-skill-output.vue?vue&type=style&index=0&id=bd4147ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4147ce",
  null
  
)

export default component.exports